import { request } from '@umijs/max';
import type { ApiPageRequest, ApiPageResult } from '@/services/apiResponse';
import { getNotificationApiUrl } from '@/services/util';

export interface SiteMessageItem {
  siteMessageId: string;
  campaignId?: string;
  title: string;
  content?: string;
  publishedAt?: string;
  readAt?: string;
  unread?: boolean;
}

export interface SiteMessageListParams {
  unread?: boolean;
}

export interface SiteMessageListPageParams extends ApiPageRequest {
  page: {
    pageNo: number;
    pageSize: number;
  };
  title?: string;
  publishedAtStart?: number;
  publishedAtEnd?: number;
  unread?: boolean;
}

export type SiteMessageListPageResult = ApiPageResult<SiteMessageItem>;

export interface SiteMessageListResult {
  list: SiteMessageItem[];
}

export interface SiteMessageIdParams {
  siteMessageId: string;
}

export interface SiteMessageUnreadCountResult {
  count: number;
}

export interface SiteMessageMarkAllReadResult {
  updatedCount?: number;
}

/** 我的站内信列表（不分页） */
export async function getSiteMessageList(
  params?: SiteMessageListParams,
  options?: { [key: string]: unknown },
) {
  return request<SiteMessageListResult>(
    getNotificationApiUrl('site-message/list'),
    {
      method: 'POST',
      data: params || {},
      ...(options || {}),
    },
  );
}

/** 我的站内信分页列表 */
export async function getSiteMessageListPage(
  params: SiteMessageListPageParams,
  options?: { [key: string]: unknown },
) {
  return request<SiteMessageListPageResult>(
    getNotificationApiUrl('site-message/list-page'),
    {
      method: 'POST',
      data: params,
      ...(options || {}),
    },
  );
}

/** 我的站内信详情 */
export async function getSiteMessageDetail(
  params: SiteMessageIdParams,
  options?: { [key: string]: unknown },
) {
  return request<SiteMessageItem>(getNotificationApiUrl('site-message/detail'), {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}

/** 标记站内信已读 */
export async function markSiteMessageRead(
  params: SiteMessageIdParams,
  options?: { [key: string]: unknown },
) {
  return request<Record<string, unknown>>(
    getNotificationApiUrl('site-message/mark-read'),
    {
      method: 'POST',
      data: params,
      ...(options || {}),
    },
  );
}

/** 全部站内信已读 */
export async function markAllSiteMessageRead(
  options?: { [key: string]: unknown },
) {
  return request<SiteMessageMarkAllReadResult>(
    getNotificationApiUrl('site-message/mark-all-read'),
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}

/** 我的站内信未读数 */
export async function getSiteMessageUnreadCount(
  options?: { [key: string]: unknown },
) {
  return request<SiteMessageUnreadCountResult>(
    getNotificationApiUrl('site-message/unread-count'),
    {
      method: 'POST',
      data: {},
      ...(options || {}),
    },
  );
}
